module.exports = __webpack_public_path__ + "img/csuc.d2d0b76e.svg";